<div class="header-container">
  <header class="header">
    <div class="header-content">
      <a href="https://www.eeaoc.gob.ar/">
        <img src="assets/images/logos/logo_eeaoc.png" alt="Logo EEAOC" class="logo">
      </a>

      <div class="header-actions">
        <a *ngIf="alertText" class="alert-pill" routerLink="/estado-actual" [title]="alertText">
          <mat-icon>warning_amber</mat-icon>
          <span>Alerta vigente</span>
        </a>

        <app-navbar></app-navbar>
      </div>
    </div>

    <nav class="fixed-toolbar" aria-label="Navegación principal">
      <button type="button" class="menu-toggle menu-mobile" (click)="toggleMenu()"
        [attr.aria-expanded]="menuOpen" aria-label="Abrir menú de navegación">
        <mat-icon>{{ menuOpen ? 'close' : 'menu' }}</mat-icon>
        <span>Menú</span>
      </button>

      <ul class="menu-desktop">
        <li *ngFor="let item of navItems">
          <a [routerLink]="item.path" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: item.exact ?? false }">{{ item.label }}</a>
        </li>
      </ul>

      <ul class="menu-mobile-panel" *ngIf="menuOpen">
        <li *ngFor="let item of navItems">
          <a [routerLink]="item.path" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: item.exact ?? false }" (click)="closeMenu()">{{ item.label }}</a>
        </li>
      </ul>
    </nav>

    <div class="header-bar" aria-hidden="true"></div>
  </header>
</div>
